import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';

import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';

import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { QuillModule } from 'ngx-quill';


/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbButtonsModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';


import { ToolbandiUiLibModule } from 'toolbandi-ui-lib';
import { ElbuildUiLibModule, AuthConfig, ElbuildCoreServicesModule } from 'elbuild-ui-lib-core';
import { ElbuildUiComponentslibModule } from 'elbuild-ui-componentslib';

import { FormsModule } from '@angular/forms';
import { BackofficeAuthModule } from './backoffice-auth/backoffice-auth.module';

import { ToastrModule } from 'ngx-toastr';

import 'reflect-metadata';
import { CoreModule } from './@core/core.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

const authConfig: AuthConfig = {
	cookieprefix: 'toolbandi',
	usertable: 'user',
	loginpage: 'signin',
	enablefeatures: true
};

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
	declarations: [
		AppComponent,
		AdminComponent,
		AuthComponent,
		NavigationComponent,
		NavContentComponent,
		NavGroupComponent,
		NavCollapseComponent,
		NavItemComponent,
		NavBarComponent,
		NavLeftComponent,
		NavSearchComponent,
		NavRightComponent,

		ConfigurationComponent,
		ToggleFullScreenDirective
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		SharedModule,
		NgbDropdownModule,
		NgbTooltipModule,
		NgbButtonsModule,
		FormsModule,
		ToolbandiUiLibModule.forRoot(),
		ElbuildUiLibModule.forRoot(authConfig),
		ElbuildUiComponentslibModule.forRoot(),
		ElbuildCoreServicesModule,
		BackofficeAuthModule,
		ToastrModule.forRoot({
			preventDuplicates: true
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			},
			defaultLanguage: 'it'
		}),
		QuillModule.forRoot({
			modules: {
				toolbar: [
					[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
					['bold', 'italic', 'underline'],
				]
			}
		}),
		CoreModule.forRoot()
	],
	providers: [NavigationItem],
	bootstrap: [AppComponent]
})
export class AppModule { }
